import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Header from "../components/header"
import Contact from "../components/Contact"

const ContactPage: React.FC = () => (
  <Layout>
    <Seo title="Contact" />
    <Header />
    <Contact />
  </Layout>
)

export default ContactPage
